import { Link } from "react-router-dom";
import type { Category } from "@/types/content";
import { getCategoryStyle } from "@/utils/format";
import { categories } from "@/mocks/categories";

interface CategoryHeaderProps {
  category: Category;
  count: number;
}

export default function CategoryHeader({ category, count }: CategoryHeaderProps) {
  const style = getCategoryStyle(category.slug);

  return (
    <section className="w-full bg-background-100 border-b border-background-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="flex flex-col md:flex-row md:items-start gap-5 md:gap-8">
          <span
            className={`w-16 h-16 md:w-20 md:h-20 shrink-0 rounded-lg flex items-center justify-center ${style.chip}`}
          >
            <i className={`${category.icon} text-3xl md:text-4xl`} aria-hidden="true"></i>
          </span>
          <div className="flex-1 min-w-0">
            <div className="flex flex-wrap items-center gap-3">
              <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 tracking-tight">
                {category.name}
              </h1>
              <span className="text-xs text-foreground-500 bg-background-50 border border-background-200 px-2.5 py-1 rounded-full">
                共 {count} 条爆料
              </span>
              <span className="inline-flex items-center gap-1 text-xs text-primary-600 bg-primary-50 border border-primary-100 px-2.5 py-1 rounded-full">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
                实时更新中
              </span>
            </div>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl">
              {category.intro}
            </p>

            <div className="mt-5 flex flex-wrap items-center gap-2">
              <span className="text-xs text-foreground-400 mr-1 whitespace-nowrap">
                其他瓜田
              </span>
              {categories
                .filter((item) => item.slug !== category.slug)
                .map((item) => (
                  <Link
                    key={item.slug}
                    to={`/category/${item.slug}`}
                    className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-background-50 border border-background-200 text-xs text-foreground-600 hover:border-primary-200 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className={item.icon} aria-hidden="true"></i>
                    {item.name}
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}